import { KitsJob, type CADUploadJob, type PartCategoriesJob, type SalesBomJob } from '@providers/job/types';
import {
  DEFAULT_JOB_TIMEOUT,
  GETCADJobResponse,
  GETSBOMJobResponse,
  type GetPartsCategoriesJobResponse,
} from '@services/productInventory';

export function useIsJobTimedOut(
  runInfo:
    | GETCADJobResponse /* TECH DEBT these are duplicate types */
    | GETSBOMJobResponse /* TECH DEBT these are duplicate types */
    | GetPartsCategoriesJobResponse /* TECH DEBT these are duplicate types */
    | CADUploadJob
    | SalesBomJob
    | PartCategoriesJob
    | KitsJob
    | undefined
): boolean {
  if (runInfo && !['FAILED', 'IN_PROGRESS_CAD_PROCESSING_FAILED'].includes(runInfo.status)) {
    const jobStartTime = new Date(runInfo.created).getTime();
    const now = new Date().getTime();

    return now - jobStartTime >= DEFAULT_JOB_TIMEOUT;
  }

  return false;
}
